goog.provide("shadow.js.shim.module$src$svg$wpp$files$folder_svg$default");
shadow.js.shim.module$src$svg$wpp$files$folder_svg$default = shadow.js.shim.module$src$svg$wpp$files$folder_svg.default;
